"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _default = exports.default = (0, _styles.makeStyles)({
  cardNumber: {
    marginBottom: '8px',
    padding: '16px',
    border: '1px solid #d2d2d2'
  },
  cardCvc: {
    boxSizing: 'border-box',
    width: '100%',
    padding: '16px',
    border: '1px solid #d2d2d2'
  },
  cardExpiry: {
    boxSizing: 'border-box',
    width: '100%',
    marginRight: '8px',
    padding: '16px',
    border: '1px solid #d2d2d2'
  },
  cards: {
    position: 'absolute',
    right: '20px',
    top: '60px'
  },
  cardImage: {
    width: '37px',
    marginLeft: 10
  },
  cardProcessing: {
    opacity: 0.5
  }
});